/* PrintABalls puck builder - storefront UI layer.
   The ONLY Shopify-specific file. Render logic lives in pab-puck-core.js and is
   shared byte-for-byte with the local QA harness, so a bad preview reproduces offline.
   Overrides currentName/currentNum because the storefront inputs are real form
   fields (#pab-nm / #pab-no) that post as line item properties. */
(function(){
  if (typeof STYLES === 'undefined') { console.error('[PAB] core did not load'); return; }
  var ROOT = document.querySelector('.pab-builder');
  if (!ROOT) return;

  var NAME_RE = /[^A-Z\u00C0-\u00DD' -]/g;
  currentName = function(){
    return (document.getElementById('pab-nm').value || '').toUpperCase().replace(NAME_RE, '');
  };
  currentNum = function(){
    return (document.getElementById('pab-no').value || '').replace(/[^0-9]/g, '');
  };

  function setProp(id, v){ var el = document.getElementById(id); if (el) el.value = v; }

  function syncProps(){
    var s = STYLES[st], p = PALS[pi], f = FONTS[fi];
    setProp('pab-p-style', s.id + ' ' + s.name);
    setProp('pab-p-pal',   p[0] + ' ' + p[1]);
    setProp('pab-p-font',  f[0] + ' ' + f[1]);
    setProp('pab-p-spec',  document.getElementById('spec').textContent || '');
    setProp('pab-p-build', (typeof PAB_BUILDER === 'string' ? PAB_BUILDER : '0'));
  }


function draw(){
  var p=PALS[pi], f=FONTS[fi][2], n=currentName(), no=currentNum(), s=STYLES[st];
  // Landing state: fields start empty so nothing is pre-filled into the order, but an
  // empty puck reads as a broken page. Show the same SMITH/27 stand-in the thumbnails
  // use. Both fields are `required`, so a blank puck cannot actually be bought.
  var isExample = !n && !no;
  document.getElementById('hero').innerHTML = puckSVG(st,p,f,n||'SMITH',no||'27','hero'+(uid++));
  document.getElementById('capStyle').textContent = s.id+' \u00B7 '+s.name;
  // Coverage class is internal taxonomy - not shown to shoppers.
  document.getElementById('capMeta').textContent = p[0]+' \u00B7 '+FONTS[fi][0];

  // The font is a customer choice, so the spec has to record it - otherwise one
  // spec describes five different pucks. Same form the Bed Builder reads.
  var spec='PAB-HKY-PUCK-'+s.id+'-'+p[0].replace('-','')+'-'+FONTS[fi][0].replace('-','')
          +'-'+(n||'NAME')+'-'+(no||'00')+'-V01-PROOF';
  document.getElementById('spec').textContent=spec;

  var w=document.getElementById('warn'), msgs=[];
  if(!s.bg) msgs.push('On this style the jersey body prints <strong>black</strong>, and your colours carry the lettering, bars and trim - the way a black jersey works. Want your main colour across the whole face? Try Twin Hem, Triple Retro, Vertical Split, Diagonal Sash or Ring Border.');
  if(n.length>=11) msgs.push('<strong>'+n.length+' letters</strong> is a long name. It still fits, but it prints small - we may suggest splitting it over two lines on your proof.');
  if(isExample) msgs.push('<strong>This is an example.</strong> Type the surname and number you want - the preview updates as you type.');
  else if(!no) msgs.push('Add a number to see the full design.');
  else if(!n) msgs.push('Add a surname to see the full design.');
  w.className = msgs.length ? 'warn on' : 'warn';
  w.innerHTML = msgs.join('<br><br>');

  document.getElementById('lenHint').textContent = n.length ? n.length+' letters \u00B7 '+(no.length||0)+'-digit number' : 'Type a surname to begin.';
  buildStyles(); buildPals();
}

function buildStyles(){
  var g=document.getElementById('styleGrid'), p=PALS[pi], f=FONTS[fi][2], n=currentName(), no=currentNum();
  g.innerHTML = STYLES.map(function(s,i){
    return '<button class="opt" type="button" aria-pressed="'+(i===st)+'" data-s="'+i+'" '+
           'title="'+s.id+' '+s.name+'">'+puckSVG(i,p,f,n||'SMITH',no||'27','th'+i)+
           '<span class="lb">'+s.name+'</span></button>';
  }).join('');
  Array.prototype.forEach.call(g.querySelectorAll('.opt'), function(b){
    b.addEventListener('click', function(){ st=+b.dataset.s; draw(); });
  });
}

function sig(s,p){var t=puckSVG(s,PALS[p],FONTS[fi][2],'SMITH','27','s');
  var h=5381; for(var i=0;i<t.length;i++) h=((h<<5)+h+t.charCodeAt(i))>>>0; return h;}

// Only offer colourways that actually produce a different puck on this style.
// On the black-body styles several palettes collapse to the same result, and
// letting someone pick one and receive another is the worst outcome here.
function visiblePals(){
  var seen={}, out=[];
  for(var i=0;i<PALS.length;i++){ var k=sig(st,i); if(seen[k]===undefined){seen[k]=i; out.push(i);} }
  return out;
}

function buildPals(){
  var g=document.getElementById('palGrid');
  var vis=visiblePals();
  if(vis.indexOf(pi)<0){ pi=vis[0]; }
  g.innerHTML = vis.map(function(i){
    var p=PALS[i], dim='';
    return '<button class="opt'+dim+'" type="button" aria-pressed="'+(i===pi)+'" data-p="'+i+'" title="'+p[1]+'">'+
           '<span class="sw-bars"><i style="background:'+p[2]+'"></i><i style="background:'+p[3]+
           '"></i><i style="background:'+p[4]+'"></i></span>'+
           '<span class="lb">'+p[0].replace('PAL-','')+'</span></button>';
  }).join('');
  window.__visCount = vis.length;
  Array.prototype.forEach.call(g.querySelectorAll('.opt'), function(b){
    b.addEventListener('click', function(){ pi=+b.dataset.p; draw(); });
  });
  var n=window.__visCount||PALS.length;
  document.getElementById('palHint').innerHTML = (n<PALS.length)
    ? '<strong>'+n+' colourways</strong> on this style. Its jersey body prints black, so colourways that differ only in their body colour would produce the same puck - those are hidden rather than offered. Or tell us your team colours and we will match them.'
    : '<strong>'+n+' colourways</strong>, or tell us your team colours and we will match them.';
}

function buildFonts(){
  var g=document.getElementById('fontGrid');
  g.innerHTML = FONTS.map(function(f,i){
    return '<button class="opt" type="button" aria-pressed="'+(i===fi)+'" data-f="'+i+'" title="'+f[1]+'">'+
           '<span class="fnum" style="font-family:\''+f[2]+'\',Impact,sans-serif">27</span>'+
           '<span class="lb">'+f[1]+'</span></button>';
  }).join('');
  Array.prototype.forEach.call(g.querySelectorAll('.opt'), function(b){
    b.addEventListener('click', function(){ fi=+b.dataset.f; draw(); buildFonts(); });
  });
}

document.getElementById('copy').addEventListener('click', function(){
  var t=document.getElementById('spec').textContent, b=this;
  if(navigator.clipboard){ navigator.clipboard.writeText(t).then(function(){
    b.textContent='Copied'; setTimeout(function(){ b.textContent='Copy order spec'; },1400); }); }
});



  // preview uses SMITH/27 as stand-ins so the puck is never blank, but the
  // posted properties stay empty until the customer actually types something.
  var _origDraw = draw;
  draw = function(){ _origDraw(); syncProps(); };

  document.getElementById('pab-nm').addEventListener('input', draw);
  document.getElementById('pab-no').addEventListener('input', draw);

  // --- Add another player -------------------------------------------------
  // Horizon's product form dispatches a bubbling 'cart:update' once an add
  // succeeds. Hooking that beats bolting on our own /cart/add.js call: no
  // duplicated cart logic and no race against Horizon serialising the form.
  // Style, colourway and font are deliberately kept - the next player on a
  // team almost always wants the same jersey. Only name and number reset.
  var pabPending = null;
  var pabForm = document.getElementById(ROOT.dataset.pabForm);
  if (pabForm) {
    pabForm.addEventListener('submit', function(){
      var n = currentName(), no = currentNum();
      pabPending = (n && no) ? (n + ' ' + no) : null;
    });
  }
  document.addEventListener('cart:update', function(){
    if (!pabPending) return;                 // ignore cart edits we did not cause
    var added = pabPending; pabPending = null;
    document.getElementById('pab-nm').value = '';
    document.getElementById('pab-no').value = '';
    draw();
    var box = document.getElementById('pabAdded');
    if (box) {
      box.innerHTML = '<b>' + added + '</b> added to your cart. Your style and colours are still set '
        + '- type the next player\u2019s name to add another, or head to the cart when you are done.';
      box.hidden = false;
    }
    try { document.getElementById('pab-nm').focus({ preventScroll: true }); } catch (e) {}
  });

  buildFonts(); draw();

  if (location.search.indexOf('pabdebug=1') > -1) {
    var sb = document.getElementById('specBox'); if (sb) sb.className = 'spec on';
    console.log('[PAB] builder', PAB_BUILDER, 'styles', STYLES.length, 'palettes', PALS.length, 'fonts', FONTS.length);
  }
})();
